import { Typography } from "@material-ui/core";
import { formatDate, getErasureReportStatus } from "../../../../sc-utilities";
import React from "react";

export const collectionTableColumns = (translations, visible, createAction, CustomChip, queryParams) =>
    [
        {
            title: translations["action"] || 'Action', field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 200 },
            filtering: false,
            render: rowData => {
                return <>
                    {createAction(rowData, translations)}
                </>
            }
        },
        {
            title: translations['id'] || 'ID', field: 'InventoryID',
            hidden: visible ? visible['ID'] : false,
            sorting: false,
            filtering: true,
            render: (rowData) => {
                let inventoryID = null;
                if (rowData.Order) {
                    inventoryID = rowData.Order.OrderInventoryID;
                }

                if (rowData.TransportColli) {
                    inventoryID = rowData.TransportColli.TransportColliInventoryID;
                }

                if (rowData.Colli) {
                    inventoryID = rowData.Colli.ColliInventoryID;
                }

                return (
                    <Typography variant={'caption'}>
                        {rowData.ErasureReportType === "custom_collection" ? translations['short_not_assigned'] || 'n/a' : inventoryID}
                    </Typography>
                );
            },
        },
        {
            title: translations["type"] || 'Type', field: 'ErasureReportType',
            hidden: visible ? visible['Type'] : false,
            lookup: {
                'order_collection': translations['order_collection'] || 'Order Collection',
                'colli_collection': translations['colli_collection'] || "Colli Collection",
                'transport_colli_collection': translations['transport_colli_collection'] || 'Transport Colli Collection',
                'custom_collection': translations['custom_collection'] || 'Custom Collection' || ''
            },
            defaultFilter: ['order_collection', 'colli_collection', 'transport_colli_collection', 'custom_collection'],
            filtering: true,
            width: 100,
            render: rowData => {
                return (
                    <Typography variant={'caption'}>
                        {rowData.ErasureReportType === "custom_collection" ? translations['custom_collection'] || 'Custom Collection' :
                            rowData.ErasureReportType === "order_collection" ? translations['order_collection'] || 'Order Collection' :
                                rowData.ErasureReportType === "colli_collection" ? translations['colli_collection'] || 'Colli Collection' :
                                    translations['transport_colli_collection'] || 'Transport Colli Collection'}
                    </Typography>
                )
            }
        },
        {
            title: translations['name'] || 'Name',
            field: 'Name',
            hidden: visible ? visible['Name'] : true,
            render: (rowData) => {
                return (
                    <Typography variant={'caption'}>
                        {rowData.ErasureReportType === "custom_collection" ? translations['short_not_assigned'] || 'n/a' : rowData.OrderID ? rowData.Order.Name : rowData.TransportColliID ? rowData.TransportColli.Name : rowData.Colli.Name}
                    </Typography>
                );
            },
        },
        {
            title: translations["username"] || 'Username', field: 'Username',
            hidden: visible ? visible['Username'] : false,
            cellStyle: { minWidth: 220, maxWidth: 220 },
            filtering: true,
            render: rowData => {
                return (
                    <Typography variant={'caption'}>
                        {rowData.User && rowData.User.Username ? rowData.User.Username : translations['short_not_assigned'] || 'n/a'}
                    </Typography>
                )
            }
        },
        {
            title: translations["status"] || 'Status', field: 'GeneratedStatus',
            hidden: visible ? visible['GeneratedStatus'] : false,
            lookup: { '0': translations['ready_to_generate'] || 'Ready to generate', '1': translations['in_progress'] || "In progress", '2': translations['generated'] || 'Generated', '-1': translations['failed'] || 'Failed' },
            defaultFilter: ['0', '1', '2', '-1'],
            filtering: true,
            width: 100,
            render: rowData => {
                return <CustomChip trimming={true} customChipKey={rowData.ColliInventoryID}
                    className={`chip${getErasureReportStatus(rowData.GeneratedStatus, 'forStyle')}`}
                    value={getErasureReportStatus(rowData.GeneratedStatus, rowData.Generated, rowData.ToGenerate, translations)} />
            }
        },
        {
            title: translations["file_name"] || 'File Name', field: 'OriginalFileName',
            hidden: visible ? visible['OriginalFileName'] : true,
            filtering: true,
            defaultFilter: queryParams?.OriginalFileName ?? null,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.OriginalFileName ? rowData.OriginalFileName : ''}</Typography>;
            }
        },
        {
            title: translations["number_of_downloads"] || 'Number of downloads', field: 'DownloadedNumber',
            hidden: visible ? visible['DownloadedNumber'] : true,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.DownloadedNumber ? rowData.DownloadedNumber : '0'}</Typography>;
            }
        },
        {
            title: translations["requested_at"] || 'Requested at', field: 'RequestedAt',
            hidden: visible ? visible['RequestedAt'] : false,
            filtering: true,
            type: 'date',
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.RequestedAt ? formatDate(rowData.RequestedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
    ]